import {getProduct, updateProduct} from "../../api/Api";
import {useState, useEffect} from 'react';
import {useParams} from "react-router";
import {Button, Card, Divider, Row, Col, Input, Select, message} from 'antd';
import {CategoryType, getOptions, ProductType, StrainType} from "../../api/Constants";
import {getSubTypeOptions} from "../../util/inventoryUtils";
import {VendorSelectWidget} from "../widget/VendorSelectWidget";

export const ProductView = ({onApiFail, refresh, onRefresh, props}) => {
    const [product, setProduct] = useState(undefined);
    const params = useParams();
    const productId = params.productId;
    const [name, setName] = useState(undefined);
    const [description, setDescription] = useState(undefined);
    const [type, setType] = useState(undefined);
    const [subtype, setSubtype] = useState(undefined);
    const [sku, setSku] = useState(undefined);

    const [strain, setStrain] = useState(undefined);
    const [brand, setBrand] = useState(undefined);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [vendorId, setVendorId] = useState(undefined);

    const [messageApi, msgContext] = message.useMessage();

    const resetProduct = (product) => {
        setName(product.name);
        setDescription(product.description);
        setType(product.type);
        setSubtype(product.subtype);
        setSku(product.sku);
        if (product.category === CategoryType.Supplies) {
            // set the brand
            setBrand(product.brand)
        } else {
            // all other products
            // set the strain
            setStrain(product.strain);
        }
    }

    useEffect(() => {
        if (productId === undefined) {
            return;
        }
        getProduct(productId).then(result => {
            setProduct(result);
            resetProduct(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [productId, refresh, onApiFail])

    const rowStyle = {textAlign: 'left', margin: '5px'}

    const onNameChange = (e) => {
        setSaveDisabled(false)
        setName(e.target.value)
    }

    const onDescriptionChange = (e) => {
        setSaveDisabled(false)
        setDescription(e.target.value)
    }

    const onTypeChange = (val) => {
        setSaveDisabled(false)
        setType(val);

        // update subtype because we've changed
        if (val !== type) {
            setSubtype(undefined);
        }
    }

    const onSubTypeChange = (val) => {
        setSaveDisabled(false)
        setSubtype(val)
    }

    const onSkuChange = (e) => {
        setSaveDisabled(false)
        setSku(e.target.value)
    }

    const onStrainChange = (val) => {
        setSaveDisabled(false)
        setStrain(val)
    }

    const onBrandChange = (e) => {
        setSaveDisabled(false)
        console.log(`brand ${e.target.value}`)
        setBrand(e.target.value);
    }

    const onVendorIdChange = (val, option) => {
        setSaveDisabled(false);
        setVendorId(option.vendor.id)
    }

    const saveChanges = () => {
        console.log('save changes')
        const options = {}
        if (name !== product.name) {
            console.log('name different')
            options.name = name;
        }
        if (description !== product.description) {
            console.log('description different')
            options.description = description;
        }
        if (type !== product.type) {
            console.log(`type different`)
            options.type = type;
        }

        if (subtype !== product.subtype) {
            console.log(`subtype different`)
            options.subtype = subtype;
        }
        if (sku !== product.sku) {
            console.log(`sku different`);
            options.sku = sku;
        }
        if (vendorId !== product.vendorId) {
            console.log(`vendor different`);
            options.vendorId = vendorId;
        }
        if (product.category === CategoryType.Supplies) {
            // set the brand
            if (brand !== product.brand) {
                console.log(`brand different`)
                options.brand = brand;
            }
        } else {
            // all other products
            // set the strain
            if (strain !== product.strain) {
                console.log(`strain different`)
                options.strain = strain;
            }
        }

        setSaveDisabled(true);
        updateProduct(productId, options).then(r => {
            messageApi.open({
                type: 'success',
                content: 'Product Updated'
            })
            if (onRefresh) onRefresh();
        }).catch(e => {
            messageApi.open({
                type: 'error',
                content: 'Failed to Update Product'
            })
        });

    }

    const resetProductChanges = () => {
        resetProduct(product);
        setSaveDisabled(true);
    }

    const productTypeOptions = getOptions(ProductType) ();
    const strainOptions = getOptions(StrainType) ();
    const productSubTypeOptions = getSubTypeOptions(type);
    const subTypeDisabled = type === (undefined) || type === null;

    const productUI = product && <div>
        <Row style={rowStyle}>
            <Col><Select options={strainOptions} placeholder={"strain"} onChange={onStrainChange} value={strain} /></Col>
        </Row>
    </div>

    const packageUI = product && <div>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={12}><Input placeholder={"Brand"} onChange={onBrandChange} value={brand} /></Col>
        </Row>
    </div>

    const content2 = product && <div>
        {msgContext}
        <Card>
        <Row style={rowStyle}>
            <Col span={12}><Input placeholder={"Name"} onChange={onNameChange} value={name}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={12}><Input placeholder={"Description"} onChange={onDescriptionChange} value={description}/></Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><Select placeholder={"Type"} onChange={onTypeChange} value={type} options={productTypeOptions} popupMatchSelectWidth={false}/></Col>
            <Col span={3}><Select placeholder={"Subtype"} onChange={onSubTypeChange} value={subtype} options={productSubTypeOptions} disabled={subTypeDisabled} popupMatchSelectWidth={false} /></Col>
        </Row>
        <Row style={rowStyle}>

        </Row>
        <Row style={rowStyle}>
            <Col span={12}><Input placeholder={"Sku"} onChange={onSkuChange} value={sku}/></Col>
        </Row>
        <Row style={rowStyle}>
            <VendorSelectWidget refersh={refresh} onApiFail={onApiFail} onSelect={onVendorIdChange} />
        </Row>
        <Row style={rowStyle}>
            <b>{CategoryType.Label[product.category]}</b>
        </Row>

        {(product.category === CategoryType.Supplies) ? packageUI: productUI}
        <Divider></Divider>
        <Row style={rowStyle}>
            <Col style={{marginRight: '5px'}}><Button onClick={resetProductChanges} disabled={product===undefined}>Clear Changes</Button></Col>
            <Col><Button onClick={saveChanges} disabled={saveDisabled}>Save</Button></Col>
        </Row>
    </Card>
    </div>

    return content2;
}